import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, Stop, LinearGradient } from "react-native-svg";
import { uniqueId } from 'lodash';

export default function DesktopSyncIcon(props) {
  const width = props.width || 60;
  const height = props.height || 60;

  const filterId = "paint0_linear_desktop" + uniqueId();
  const filterUrl = `url(#${filterId})`;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.1416 13.6826C16.1249 13.6826 13.6794 16.1281 13.6794 19.1448V32.2068C13.6794 33.4486 14.0938 34.5936 14.7918 35.5111H13.8078C11.663 38.4095 8.57141 43.3367 8.57141 43.3367C8.58153 44.2286 8.94164 45.0808 9.57415 45.7097C10.2067 46.3386 11.0609 46.6938 11.9528 46.6988H48.0278C48.9297 46.6988 49.7947 46.3405 50.4325 45.7028C51.0703 45.065 51.4286 44.2 51.4286 43.2981C51.4286 43.2981 47.2053 36.2302 45.1772 35.5284C45.8832 34.6081 46.3029 33.4564 46.3029 32.2068V19.1448C46.3029 16.1281 43.8574 13.6826 40.8407 13.6826H19.1416ZM18.0342 19.1448C18.0342 18.5332 18.53 18.0374 19.1416 18.0374H40.8407C41.4523 18.0374 41.9481 18.5332 41.9481 19.1448V32.2068C41.9481 32.8184 41.4523 33.3142 40.8407 33.3142H19.1416C18.53 33.3142 18.0342 32.8184 18.0342 32.2068V19.1448ZM45.1488 42.1387C44.5498 41.3078 43.9894 40.5929 43.5643 40.1099H16.1844L14.8126 42.1387H45.1488Z"
          fill={filterUrl}
        />
        <Defs>
          <LinearGradient
            id={filterId}
            x1="8.57141"
            y1="20.8428"
            x2="21.8589"
            y2="56.0858"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
